/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * The color map is used to map a background color token to a matching text color that will meet contrast.
 *
 * @codegen <<SignedSource::d168519874a16bbb92cfbfd4747a39b4>>
 * @codegenCommand yarn codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::10aa7e87eca39e4d6594a764e78e0698>>
 */
export default {
  'neutral.bold': 'inverse',
  'neutral.bold.hovered': 'inverse',
  'neutral.bold.pressed': 'inverse',
  'selected.bold': 'inverse',
  'selected.bold.hovered': 'inverse',
  'selected.bold.pressed': 'inverse',
  'brand.bold': 'inverse',
  'brand.bold.hovered': 'inverse',
  'brand.bold.pressed': 'inverse',
  'danger.bold': 'inverse',
  'danger.bold.hovered': 'inverse',
  'danger.bold.pressed': 'inverse',
  'warning.bold': 'warning.inverse',
  'warning.bold.hovered': 'warning.inverse',
  'warning.bold.pressed': 'warning.inverse',
  'success.bold': 'inverse',
  'success.bold.hovered': 'inverse',
  'success.bold.pressed': 'inverse',
  'discovery.bold': 'inverse',
  'discovery.bold.hovered': 'inverse',
  'discovery.bold.pressed': 'inverse',
  'information.bold': 'inverse',
  'information.bold.hovered': 'inverse',
  'information.bold.pressed': 'inverse'
};